import { backend } from "@/assets/config/server";
import axios from "axios";
import { postdata } from "./userchatcontrol";
import { useAccountStore } from "@/store/account";
const api = axios.create({
  baseURL: backend,
});

async function kirimfiles(files, idtiket, token = null) {
  try {
    //const hasilvalidasi = cekvalidasi(files)
    const validFiles = files;

    if (validFiles.length === 0) {
      alert("Tidak ada file yang valid");
      return;
    }

    var formData = new FormData();

    console.log("validFiles:", validFiles);

    validFiles.forEach((file) => {
      console.log("file:", file);
      console.log("file instanceof File:", file instanceof File);

      if (token !== null) {
        formData.append("files[]", file.file);
      } else {
        formData.append("files[]", file);
      }
    });

    formData.append("username", useAccountStore().user);

    console.log("FORM DATA:");

    for (const [key, value] of formData.entries()) {
      console.log(key, value);

      if (value instanceof File) {
        console.log("  name:", value.name);
        console.log("  type:", value.type);
        console.log("  size:", value.size);
      }
    }

    var response = null;

    if (token !== null) {
      response = await api.post(`/api/chat/${idtiket}/sendFiles`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } else {
      response = await postdata(`/api/chat/${idtiket}/sendFiles1`, formData);
    }

    return await response;
    //console.log(response);
    //alert("Upload berhasil");
  } catch (err) {
    return err;
    //console.error(err);
    //alert("Gagal upload file");
  }
}

async function kirimsinglefile(file, idtiket, type) {
  var files = [];
  if (type == "gambar") {
    files = file;
  } else if (type == "file") {
    files = file;
  }

  return await kirimfiles(files, idtiket);
}

export { kirimfiles, kirimsinglefile };
